var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9207 0.179688H6.69072H1.08072C0.120725 0.179688 -0.359275 1.33969 0.320725 2.01969L5.50072 7.19969C6.33072 8.02969 7.68073 8.02969 8.51073 7.19969L10.4807 5.22969L13.6907 2.01969C14.3607 1.33969 13.8807 0.179688 12.9207 0.179688Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceDrop);
export default __webpack_public_path__ + "static/media/PerformanceDrop.c0188ae80d3d77c71728176516b230f5.svg";
export { ForwardRef as ReactComponent };